export default __webpack_public_path__ + "static/media/vrlab2.cb1fbd78.png";